import { useMemo } from "react";

import { Button, HStack, Text } from "@chakra-ui/react";

import { FileUri } from "api";
import Empty from "components/Empty";
import { SortableCardTable } from "components/SortableTable";
import LoadingSpinner from "components/LoadingSpinner";
import useDocumentFiles from "hooks/api/documents/useDocumentFiles";
import useDownloadFile from "hooks/useDownloadFile";
import useSelectedCustomerCode from "hooks/useSelectedCustomerCode";
import { DownloadIcon } from "icons";

export const documentsFilesColumns: ColumnDefinition<FileUri>[] = [
  {
    property: "filename",
    columnLabel: "File Name",
    overflow: "visible",
  },
  {
    property: "category",
    columnLabel: "File Type",
  },
];

const FilesTable = () => {
  const selectedCustomerCodes = useSelectedCustomerCode();

  const { data: documentFiles = [], isLoading: documentFilesLoading } =
    useDocumentFiles(selectedCustomerCodes);
  const downloadDocumentFile = useDownloadFile();

  const filesTableEntries = useMemo(() => {
    return documentFiles?.map((value) => {
      return {
        ...value,
        filename: (
          <Button
            variant="link"
            onClick={() => downloadDocumentFile(value)}
            textAlign="left"
            wordBreak="break-all"
            whiteSpace="break-spaces"
          >
            <HStack spacing={1} align="flex-start">
              <Text color="inherit" fontWeight="semibold" textStyle="body2">
                {value.filename}
              </Text>
              <DownloadIcon />
            </HStack>
          </Button>
        ),
      };
    });
  }, [documentFiles, downloadDocumentFile]);

  if (documentFilesLoading) {
    return <LoadingSpinner />;
  }

  return (
    <>
      {documentFiles && documentFiles.length > 0 ? (
        <SortableCardTable
          values={filesTableEntries}
          columns={documentsFilesColumns as ColumnDefinition[]}
        />
      ) : (
        <Empty
          title="No results found"
          maxWidth="400px"
          message="No files yet"
        />
      )}
    </>
  );
};

export default FilesTable;
